import React from 'react';
import { getIsTrainIncident } from '@rsos/base-utils';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertTypes';
import AlertInfoWindowContent from './AlertInfoWindowContent';
import { StyledAlertPopover, StyledPopoverCaret } from './AlertPopover.styles';

const MemoizedAlertPopover = React.memo(({ x, y, data, isAllView }) => {
  const alert = data?.alert;
  if (Object.keys(alert).length !== 0) {
    const coord = {
      x: x || 0,
      y: y || 0,
    };
    let normalizedY = coord.y;

    const isTrainIncident = getIsTrainIncident(
      alert.emergency_type?.name,
      true,
    );

    const isTrainOrAAA =
      alert.emergency_type?.name === ACTIVE_ASSAILANT || isTrainIncident;
    const { street_1, street_2, city, state } = alert.location?.civic || {};
    const noAddress = !street_1 && !street_2 && !city && !state;

    const isExtendedWidth = isAllView || isTrainOrAAA;

    if (isTrainOrAAA && isAllView && !noAddress) {
      // AAA and Train alerts due to the large title need the popover to be placed higher, otherwise it flickers on hover
      normalizedY -= 25;
    }

    return (
      <StyledAlertPopover
        x={coord.x}
        y={normalizedY}
        isExtendedWidth={isExtendedWidth}
      >
        <AlertInfoWindowContent data={data} isAllView={isAllView} />
        <StyledPopoverCaret isGoogleMap />
      </StyledAlertPopover>
    );
  }
  return null;
});

export default MemoizedAlertPopover;
